import BaseComponent from "../../baseComponent.js";

export default class ExpandChart extends BaseComponent {
  constructor(props) {
    super(props);

    this.ratio = {
      "12M": ["4M", "1.5M", "4M", "3M", "1M", "5M", "4M", "3M"],
      "10M": ["3M", "1.5M", "4M", "2M", "1M", "4M", "4M", "2M"],
      "2M": ["0.5M", "0.5M", "0.5M", "0.5M", "0.5M", "1M", "0.5M", "0.5M"],
      "4M": ["0.5M", "0.5M", "1M", "1M", "1.5M", "2M", "1M", "1M"],
      "20M": ["8M", "4M", "8M", "3M", "1M", "9M", "8M", "3M"],
      "8M": ["2M", "1M", "4M", "1M", "1M", "3M", "4M", "1M"],
      "50M": ["15M", "3M", "10M", "20M", "5M", "20M", "10M", "20M"],
    }
  }

  hideClickIndicator(id) {
    $("#" + id).stop(true, true).css('display', 'none');
  }

  showClickIndicator(id, delay) {

    setTimeout(function () {
      var target = $("#" + id);
      target.css({opacity: 0}).show();
      target.animate({opacity: 1}, 500);

      target.find(".inner-ring").show();
      setTimeout(function () {
        target.find(".mid-ring").show();
      }, 300);
      setTimeout(function () {
        target.find(".outer-ring").show();
      }, 600);

      setTimeout(function () {
        target.animate({opacity: 0}, 500, function () {
          target.hide();
        });
      }, 6300);
    }, delay);
  }

  componentDidMount() {
    var that = this;

    var blackArrow = {
      'background': "url('../../../img/arrow-black.svg') no-repeat",
      'background-size': '100% 100%'
    };
    var revertArrow = {
      'background': '',
      'background-size': ''
    }

    function startPulseRing($target) {
      var top = parseInt($target.css('top')) - 35;
      var left = parseInt($target.css('left')) - 35;
      $('#pulse-ring').css({
        top: top,
        left: left,
        display: 'initial'
      });
    };

    function stopPulseRing() {
      $('#pulse-ring').css('display', 'none');
    }

    var $barx = $('.barx');
    var $arrowB3m = $('#ar-b3m-fxrisk');
    var $arrowB1m = $('#ar-b1m-fxrisk');
    $barx.mouseover(function (e) {
      startPulseRing($(e.currentTarget));
      $arrowB3m.addClass("black-arrow");
      $arrowB1m.addClass("black-arrow");
    }).mouseleave(function () {
      stopPulseRing();
      $arrowB3m.removeClass("black-arrow");
      $arrowB1m.removeClass("black-arrow");
    });

    var $boa = $('#boa');
    var $arrowBoa = $('#ar-boa-fxrisk');
    $boa.mouseover(function (e) {
      startPulseRing($(e.currentTarget));
      $arrowBoa.addClass("black-arrow");
    }).mouseleave(function () {
      stopPulseRing();
      $arrowBoa.removeClass("black-arrow");
    });

    var $hsfx = $('#hsfx');
    var $arrowHsfx = $('#ar-hsfx-fxrisk');
    $hsfx.mouseover(function (e) {
      startPulseRing($(e.currentTarget));
      $arrowHsfx.addClass("black-arrow");
    }).mouseleave(function () {
      stopPulseRing();
      $arrowHsfx.removeClass("black-arrow");
    });

    var $fxRisk = $('#fx-risk');
    var $arrowFxRisk = $('#ar-fxrisk-fxsales');
    $fxRisk.mouseover(function (e) {
      startPulseRing($(e.currentTarget));
      $arrowFxRisk.addClass("black-arrow");
    }).mouseleave(function () {
      stopPulseRing();
      $arrowFxRisk.removeClass("black-arrow");
    });

    var $fxSales = $('#fx-sales');
    var $arrowFxSales = $('#ar-fxsales-loblaw');
    $fxSales.mouseover(function (e) {
      startPulseRing($(e.currentTarget));
      $arrowFxSales.addClass("black-arrow");
    }).mouseleave(function () {
      stopPulseRing();
      $arrowFxSales.removeClass("black-arrow");
    })

    var $loblaw = $('#loblaw');
    $loblaw.mouseover(function (e) {
      startPulseRing($(e.currentTarget));
    }).mouseleave(function () {
      stopPulseRing();
    })

    this.showClickIndicator("click-indicator");

    // register click events
    $('#loblaw').on('click touchend', this.onLoblawClick);
    $('#fx-risk').on('click touchend', this.onFxRiskClick);
    $('#fx-risk-clone').on('click touchend', this.onFxRiskCloneClick);
    $('#pie-label-barx').on('click touchend', this.onPieBarxLabelClick);
    $('#pie-label-boa').on('click touchend', this.onPieBoaLabelClick);
    $('#pie-label-hsfx').on('click touchend', this.onPieHsfxLabelClick);
    $('#expand-chart-container').on('click touchend', function (e) {
      if ($(e.toElement).attr('id') === 'ah-overlay') {
        that.closeOverlayPieChart();
      }
    });
  }

  onLoblawClick() {
    $('#pulse-ring').css('display', 'none');

    $('#loblaw').css('display', 'initial').addClass('expand-loblaw-move-left');
    $('#fx-sales').css('display', 'initial').addClass('expand-fxsales-move-right');
    $('#fx-risk').css('display', 'initial').addClass('expand-fxrisk-move-right');
    $('#barx-3m').css('display', 'initial').addClass('expand-barx3m-move-up');
    $('#barx-1-5m').css('display', 'initial').addClass('expand-barx-1-5m-move-up');
    $('#boa').css('display', 'initial').addClass('expand-boa-move-right');
    $('#hsfx').css('display', 'initial').addClass('expand-hsfx-move-down');
    $('#barx-1m').css('display', 'initial').addClass('expand-barx1m-move-down');

    $('#ar-b3m-fxrisk').addClass('ar-fade-in');
    $('#ar-b15m-fxrisk').addClass('ar-fade-in');
    $('#ar-boa-fxrisk').addClass('ar-fade-in');
    $('#ar-hsfx-fxrisk').addClass('ar-fade-in');
    $('#ar-b1m-fxrisk').addClass('ar-fade-in');
    $('#ar-fxrisk-fxsales').addClass('ar-fade-in');
    $('#ar-fxsales-loblaw').addClass('ar-fade-in');

    this.hideClickIndicator("click-indicator");
    this.showClickIndicator("click-indicator2", 3000);

  }

  onFxRiskClick(e) {
    this.hideClickIndicator('click-indicator2');
    var $fxRiskClone = $('#fx-risk-clone').css('display', 'initial');
    var $whiteOverlay = $('#ah-overlay').fadeIn({
      duration: 600,
      complete: function () {
        $fxRiskClone.animate({
          'top': '200px',
          'left': '0px',
          'width': '90px',
          'height': '90px',
          'padding-top': '20px'
        }, {
          complete: function () {
            $fxRiskClone.css({
              'border': '2px solid White',
              'width': '92px',
              'height': '92px'
            });
            $('#fill-ratio-wrapper').css('display', 'initial');
            var pieData = [{
              value: 4,
              color: "#8e7cc3"
            },
              {
                value: 2,
                color: "#b0c347"
              }, {
                value: 4,
                color: "#3ba4ed"
              }];

            var myPie = new Chart(document.getElementById("fill-ratio-pie").getContext("2d")).Pie(pieData, {
              animationSteps: 70,
              animationEasing: 'easeInOutQuart',
              segmentShowStroke: true
            });
          }
        });
        $fxRiskClone.find('.title').animate({
          'font-size': '18px'
        });
        $fxRiskClone.find('.details').animate({
          'font-size': '15px',
          'line-height': '15px'
        });
      }
    });

    e.stopPropagation();
  }

  onPieBarxLabelClick(e) {
    $('#bank-ratio-wrapper #pie-label-3m').css('display', 'initial');
    $('#bank-ratio-wrapper #pie-label-1m').css('display', 'initial');
    $('#bank-ratio-wrapper #pie-label-15m').css('display', 'initial');
    $('#bank-ratio-wrapper #pie-label-4m').css('display', 'none');

    $('#bank-ratio-wrapper #pie-label-2m').css('display', 'none');

    $('#bank-ratio-wrapper').addClass('animated zoomOut');
    setTimeout(function () {
      var $bankRatioWrapper = $('#bank-ratio-wrapper');
      $bankRatioWrapper.removeClass('animated zoomOut').css('display', 'initial');
      var pieData = [{
        value: 3,
        color: "#8e7cc3"
      },
        {
          value: 1.5,
          color: "#cc0000"
        }, {
          value: 1,
          color: "#8e7cc3"
        },
        {
          value: 8.25,
          color: "White"
        }];

      $('#bank-ratio-pie').remove();
      $bankRatioWrapper.append($('<canvas id="bank-ratio-pie" width="290" height="290"></canvas>'));
      document.getElementById('bank-ratio-pie').width = 290;
      document.getElementById('bank-ratio-pie').height = 290;
      this.barxPie = new Chart(document.getElementById("bank-ratio-pie").getContext("2d")).Pie(pieData, {
        animationSteps: 70,
        animationEasing: 'easeInOutQuart',
        segmentShowStroke: true
      });
    }, 200);

    e.stopPropagation();
  }

  onPieHsfxLabelClick(e) {
    // hide all barx labels
    $('#bank-ratio-wrapper #pie-label-3m').css('display', 'none');
    $('#bank-ratio-wrapper #pie-label-1m').css('display', 'none');
    $('#bank-ratio-wrapper #pie-label-15m').css('display', 'none');
    $('#bank-ratio-wrapper #pie-label-4m').css('display', 'none');

    $('#bank-ratio-wrapper #pie-label-2m').css('display', 'initial');

    $('#bank-ratio-wrapper').addClass('animated zoomOut');
    setTimeout(function () {
      var $bankRatioWrapper = $('#bank-ratio-wrapper');
      $bankRatioWrapper.removeClass('animated zoomOut').css('display', 'initial');
      var pieData = [{
        value: 4,
        color: "White"
      },
        {
          value: 2,
          color: "#b0c347"
        }, {
          value: 4,
          color: "White"
        }];

      $('#bank-ratio-pie').remove();
      $bankRatioWrapper.append($('<canvas id="bank-ratio-pie" width="290" height="290"></canvas>'));
      document.getElementById('bank-ratio-pie').width = 290;
      document.getElementById('bank-ratio-pie').height = 290;
      this.barxPie = new Chart(document.getElementById("bank-ratio-pie").getContext("2d")).Pie(pieData, {
        animationSteps: 70,
        animationEasing: 'easeInOutQuart',
        segmentShowStroke: true
      });
    }, 200);

    e.stopPropagation();
  }

  onPieBoaLabelClick(e) {
    // hide all other labels
    $('#bank-ratio-wrapper #pie-label-3m').css('display', 'none');
    $('#bank-ratio-wrapper #pie-label-1m').css('display', 'none');
    $('#bank-ratio-wrapper #pie-label-15m').css('display', 'none');
    $('#bank-ratio-wrapper #pie-label-2m').css('display', 'none');

    $('#bank-ratio-wrapper #pie-label-4m').css('display', 'initial');

    $('#bank-ratio-wrapper').addClass('animated zoomOut');
    setTimeout(function () {
      var $bankRatioWrapper = $('#bank-ratio-wrapper');
      $bankRatioWrapper.removeClass('animated zoomOut').css('display', 'initial');
      var pieData = [{
        value: 4,
        color: "White"
      },
        {
          value: 2,
          color: "White"
        }, {
          value: 4,
          color: "#3ba4ed"
        }];

      $('#bank-ratio-pie').remove();
      $bankRatioWrapper.append($('<canvas id="bank-ratio-pie" width="290" height="290"></canvas>'));
      document.getElementById('bank-ratio-pie').width = 290;
      document.getElementById('bank-ratio-pie').height = 290;
      this.barxPie = new Chart(document.getElementById("bank-ratio-pie").getContext("2d")).Pie(pieData, {
        animationSteps: 70,
        animationEasing: 'easeInOutQuart',
        segmentShowStroke: true
      });
    }, 200);

    e.stopPropagation();
  }

  onFxRiskCloneClick(e) {
    this.closeOverlayPieChart();
    e.stopPropagation();
  }

  closeOverlayPieChart() {
    var that = this;
    $('#bank-ratio-wrapper').addClass('animated zoomOut');
    $('#fill-ratio-wrapper').addClass('animated zoomOut');
    $('#fx-risk-clone').addClass('animated fadeOut');
    $('#ah-overlay').addClass('animated fadeOut');
    setTimeout(function () {
      $('#bank-ratio-wrapper').css({
        'display': ''
      }).removeClass('animated zoomOut');

      $('#fill-ratio-wrapper').css({
        'display': ''
      }).removeClass('animated zoomOut');

      var $fxRiskClone = $('#fx-risk-clone');
      $fxRiskClone.css({
        'display': 'none',
        'top': '',
        'left': '',
        'width': '',
        'height': '',
        'padding-top': '',
        'border': ''
      }).removeClass('animated fadeOut');

      $fxRiskClone.find('.title').css({
        'font-size': ''
      });

      $fxRiskClone.find('.details').css({
        'font-size': '',
        'padding-top': ''
      });

      $('#ah-overlay').css('display', 'none').removeClass('animated fadeOut');
    }, 1000);
  }

  render() {
    return (
      <div id="expand-chart-container">
        <div id="loblaw" className="ah-circle" data-id="loblaw">
          <div className="title">
            Loblaw
          </div>
          <div className="details">
            buy<br />
            {this.props.volume} USD
          </div>
        </div>

        <div id="fx-sales" className="ah-circle" data-id="fx-sales">
          <div className="title">
            FX Sales
          </div>
          <div className="details">
            buy<br />
            {this.props.volume} USD
          </div>
        </div>

        <div id="fx-risk" className="ah-circle" data-id="fx-risk">
          <div className="title">
            FX Risk
          </div>
          <div className="details">
            buy<br />
            {this.props.volume} USD
          </div>
        </div>

        <div id="barx-3m" className="ah-circle fold-out barx" data-id="barx-3m">
          <div className="title">
            BARX
          </div>
          <div className="details">
            sold<br />
            {this.ratio[this.props.volume][0]} USD
          </div>
        </div>

        <div id="barx-1-5m" className="ah-circle fold-out barx" data-id="barx-1-5m">
          <div className="title">
            BARX
          </div>
          <div className="details">
            reject<br />
            {this.ratio[this.props.volume][1]} USD
          </div>
        </div>

        <div id="boa" className="ah-circle fold-out" data-id="boa">
          <div className="title">
            BOA
          </div>
          <div className="details">
            sold<br />
            {this.ratio[this.props.volume][2]} USD
          </div>
        </div>

        <div id="hsfx" className="ah-circle fold-out" data-id="hsfx">
          <div className="title">
            HSFX
          </div>
          <div className="details">
            sold<br />
            {this.ratio[this.props.volume][3]} USD
          </div>
        </div>

        <div id="barx-1m" className="ah-circle fold-out barx" data-id="barx-1m">
          <div className="title">
            BARX
          </div>
          <div className="details">
            sold<br />
            {this.ratio[this.props.volume][4]} USD
          </div>
        </div>

        <div id="ar-b3m-fxrisk" className="expand-arrow"></div>
        <div id="ar-b15m-fxrisk" className="expand-arrow-reject"></div>
        <div id="ar-boa-fxrisk" className="expand-arrow"></div>
        <div id="ar-hsfx-fxrisk" className="expand-arrow"></div>
        <div id="ar-b1m-fxrisk" className="expand-arrow"></div>
        <div id="ar-fxrisk-fxsales" className="expand-arrow"></div>
        <div id="ar-fxsales-loblaw" className="expand-arrow"></div>

        <div id="ah-overlay"></div>
        <div id="fx-risk-clone" className="ah-circle" data-id="fx-risk">
          <div className="title">
            FX Risk
          </div>
          <div className="details">
            buy<br />
            {this.props.volume} USD
          </div>
        </div>
        <div id="fill-ratio-wrapper" style={{fontSize: "10px", lineHeight: "10px"}}>
          <canvas id="fill-ratio-pie" width="200" height="200"></canvas>
          <div id="pie-label-barx" data-id="barx">
            BARX<br />
            {this.ratio[this.props.volume][5]}
          </div>
          <div id="pie-label-boa" data-id="boa">
            BOA<br />
            {this.ratio[this.props.volume][6]}
          </div>
          <div id="pie-label-hsfx" data-id="hsfx">
            HSFX<br />
            {this.ratio[this.props.volume][7]}
          </div>
        </div>

        <div id="bank-ratio-wrapper">
          <canvas id="bank-ratio-pie" width="290" height="290"></canvas>
          <div id="pie-label-3m" data-id="barx-3m">
            {this.ratio[this.props.volume][0]}
          </div>
          <div id="pie-label-1m" data-id="barx-1m">
            {this.ratio[this.props.volume][4]}
          </div>
          <div id="pie-label-15m" data-id="barx-1-5m">
            {this.ratio[this.props.volume][1]}
          </div>
          <div id="pie-label-2m" data-id="hsfx">
            {this.ratio[this.props.volume][7]}
          </div>
          <div id="pie-label-4m" data-id="boa">
            {this.ratio[this.props.volume][6]}
          </div>
        </div>

        <div id="pulse-ring"></div>
        <div id="click-indicator" style={{top: 221, left: -9, zIndex: 1000}}>
          <div className="outer-ring"></div>
          <div className="mid-ring"></div>
          <div className="inner-ring"></div>
          <img className="hand" src="../img/cursor-hand.png" height="36" width="28"></img>
        </div>
        <div id="click-indicator2" style={{top: 221, left: 66, zIndex: 1000}}>
          <div className="outer-ring"></div>
          <div className="mid-ring"></div>
          <div className="inner-ring"></div>
          <img className="hand" src="../img/cursor-hand.png" height="36" width="28"></img>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/auto-hedging-widget/expandChart.jsx